export default __webpack_public_path__ + "09bd13e353e891c253388c0b36662229.svg";